module.exports = __webpack_public_path__ + "static/ico_airbnb-c1fc1b39faa9c07e4069ab50e4878d55.png";